export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-previous-33e950dda9e6340816e52f311ff3142f.svg";